import React, { useContext, useEffect } from 'react';
import AuthLayout from '../../../components/auth-layout';
import { featureFlagsContext } from '../../../providers/FeatureFlagsProvider';
import { navigate } from 'gatsby';
import routes from '../../../routes';
import useInstallerAuth from '../../../hooks/pge-plus/useInstallerAuth';
import InvoicePaymentRegister from '../../../components/invoice-payment-portal/auth/Register';

export default function Auth() {
 
  const { isAuthenticated } = useInstallerAuth();


  return isAuthenticated ? null : (
    <AuthLayout footer={<></>} showLeft={false}>
      <InvoicePaymentRegister />
    </AuthLayout>
  );
}
